"use client";

import { usePathname } from "next/navigation";
import { useState } from "react";
import { Toaster } from "sonner";

import { PostHogAuthIntegration } from "@/dashboard/analytics/PostHogAuthIntegration";
import { PostHogProvider } from "@/dashboard/analytics/PostHogProvider";
import AuthProvider from "@/dashboard/contexts/auth-context";
import { BannerProvider } from "@/dashboard/contexts/banner-context";
import FeatureProvider from "@/dashboard/contexts/feature-context";
import QueryProvider from "@/dashboard/contexts/query-client-context";
import { HubRealtimeProvider } from "@/dashboard/features/hub/realtime/hub-realtime-context";
import { isMidmarketPath } from "@/lib/midmarket/hub-hosts.mjs";

export function Providers({ children }: { children: React.ReactNode }) {
  // Read once: after a client navigation usePathname returns the browser path, not the rewritten /midmarket one.
  const pathname = usePathname();
  const [isMidmarket] = useState(() => isMidmarketPath(pathname));
  if (isMidmarket) {
    return <>{children}</>;
  }
  return (
    <PostHogProvider>
      <QueryProvider>
        <AuthProvider>
          <PostHogAuthIntegration />
          <FeatureProvider>
            <HubRealtimeProvider>
              <BannerProvider>
                {children}
                <Toaster position="top-center" />
              </BannerProvider>
            </HubRealtimeProvider>
          </FeatureProvider>
        </AuthProvider>
      </QueryProvider>
    </PostHogProvider>
  );
}
